export const ReasonsForAttending = ["Baseline screen", "Routine surveillance", "Repeat test for previous anomaly"] as const;
export type ReasonForAttending = (typeof ReasonsForAttending)[number];
